import script from "./ClosedWorkOrdersReport.vue?vue&type=script&setup=true&lang=js"
export * from "./ClosedWorkOrdersReport.vue?vue&type=script&setup=true&lang=js"

import "./ClosedWorkOrdersReport.vue?vue&type=style&index=0&id=2936400a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2936400a"]])

export default __exports__